import React from 'react';
import {
  Select,
  MenuItem,
  Chip,
  Box,
  FormControl,
  InputLabel,
  SelectChangeEvent,
  selectClasses
} from '@mui/material';

const SelectorChips = ({
  options = [],
  selected = [],
  onChange = () => {},
  placeholder = 'Selecciona opciones',
  disabled = false,
  fullWidth = true,
  ...restProps
}) => {
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;


    onChange(typeof value === 'string' ? value.split(',') : value);
  };

  return (
    <FormControl fullWidth>
      <Select
        multiple
        value={selected}
        onChange={handleChange}
        displayEmpty
        sx={{
            backgroundColor: 'white',
            color: 'black',
            '& .MuiSelect-icon': {
              color: 'black',
            },
            [`& .${selectClasses.select}`]: {
              display: 'flex',
              alignItems: 'center',
              gap: '2px',
              pl: 1,
            },
          }}
          {...restProps}  
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <span style={{ color: '#9e9e9e' }}>{placeholder}</span>;
          }

          return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          );
        }}
      >
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectorChips;
